import { v4 as uuidv4 } from 'uuid';

const OS_LABELS = {
    windows: 'Windows',
    macos:   'MacOs',
    android: 'Android',
    ios:     'iOS',
    ipados:  'iPadOS',
    tvos:    'tvOS',
};

function formatOS(rawOS) {
    const cleaned = (rawOS || '').replace(/\+/g, ' ').trim();
    if (!cleaned) return '';

    const strippedLower = cleaned.toLowerCase().replace(/\s+/g, '');
    const knownKey = Object.keys(OS_LABELS).find((key) => strippedLower.startsWith(key));
    if (knownKey) return OS_LABELS[knownKey];

    return cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
}

function formatDevice(rawDevice) {
    const cleaned = (rawDevice || '').trim();
    if (!cleaned) return '';
    return cleaned
        .toLowerCase()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}

function dedupeDevices(subscriptions) {
    const labels = (subscriptions || [])
        .flatMap((subscription) => subscription.applications || [])
        .map((app) => {
            const device = formatDevice(app.device);
            const os = formatOS(app.os);
            return device && os ? `${device} - ${os}` : null;
        })
        .filter(Boolean);

    return [...new Set(labels)];
}

function updateConnectedDevices(subscriptions) {
    const devices = dedupeDevices(subscriptions);

    this.devices = devices;
    // Spread existing profileDisplay so this doesn't race a getProfile() rebuild.
    this.profileDisplay = {
        ...this.profileDisplay,
        connectedDevices: devices.join(', '),
    };
    this.observed.devices = uuidv4();
    this.observed.profile = uuidv4();
}

export default updateConnectedDevices;
